﻿$.fn.dxCtrlPopupIa = function custom_dxCtrlPopupIa(option) {
    if (option == "instance") {
        return this.instance;
    }
    else {
        this.addClass("dx-ctrlpopupia dx-ctrl");
        this.createInstance(new cdxCtrlPopupIa(this, option));
    }
    return this;
}

window.cdxCtrlPopupIa = function (container, option) {
    var Me = this;

    this.option = function (name, value) {
        if (typeof value == 'undefined') {
            return option[name];
        }
        else {
            option[name] = value;
        }
    }

    if (typeof option.bddCtrl.utiCourantParaJson.width_popup_ia == "undefined") option.bddCtrl.utiCourantParaJson.width_popup_ia=400
    var popup = null
    function mConstruit() {
        container.empty();
        popup = container.appendTo("body").dxCtrlPopupBase({
            shading: false,
            height: "90%",
            width: option.bddCtrl.utiCourantParaJson.width_popup_ia,
            showTitle: true,
            fullScreen: false,
            resizeEnabled: true,
            dragEnabled: true,
            showMaximize: false,
            ShowMinimize: false,
            showCloseButton: false,
            position: {
                my: "right top",
                at: "right top",
                of: "body",
                offset: { x: -20, y: 70 }
            },
            titleTemplate: function (titleElement) {
                var $Table = $("<table style='margin:0 5px;'/>").appendTo(titleElement)
                var $Tr = $("<tr/>").appendTo($Table)
                var $Td = $("<td style='width:100%'><i class='fafa fafa-mia dx-theme-accent-as-text-color'></i> <span style='font-size:90%'>MIA répond à vos questions...</span></td>").appendTo($Tr)
                var $Td = $("<td style='width:1px'/>").appendTo($Tr)
                var dxBtClose = $("<div class='dxbtclose'/>").appendTo($Td).dxCtrlButton({
                    icon: 'fas fa-times',
                    width: HeightButton - 2,
                    height: HeightButton - 2,
                    onClick: function (e) {
                        popup.reduce()
                        Me.visible = false;
                    }
                }).dxCtrlButton("instance");
            },
            contentTemplate: function (contentElement) {
                contentElement.closest(".dx-popup-normal").css({
                    "background-color": theme.backgroundcolorTooltip,
                    "box-shadow": "rgb(0, 0, 0) 0px 0px 100px 20px, rgb(0, 0, 0) 0px 0px 5px 5px"
                })
                contentElement.css("padding", "0 15px 15px 15px")

                var htmlIntro = "<div>Bonjour,<br/>je suis MIA, l’IA experte de <b>" + parametre.nom + "</b> 👋.<br/>Vous pouvez me poser toutes vos questions sur ce que vous souhaitez faire avec le logiciel : je ferai de mon mieux pour vous répondre clairement et efficacement.<br/><br/>"
                if (option.bddCtrl.objCptCli.objetMetier.hasFiltreAvance()) {
                    htmlIntro += "<div style='font-size:80%;line-height:1.4;'>(Je ne peux vous répondre que sur l'utilisation de " + parametre.nom + ". Si vous voulez faire des recherches sur vos fiches, <a href='" + parametre.url_cognoss + "/0/55/Interroger_votre_base_en_langage_naturelle_avec_MIA/bc'>utiliser les filtres dans la grille de votre base de données</a>)<br/>"
                }
                htmlIntro += "(Vous pouvez aussi visiter <a href='" + parametre.url_cognoss + "' target='_blank'>la base de connaissance</a> qui regroupe les articles sur lesquels je me base pour vous répondre)<br/>(Vous pouvez aussi <a href='javascript:void(0)' onClick='page.dxMenuLeft.mShowSupport(null,true)'>🎟️ créer un ticket de support</a>, nous vous répondrons trés rapidement)<br/>(Vous pouvez enfin <a href='" + parametre.baseAppli.url_planiti_rdv + "' target='_blank'>prendre un rendez-vous téléphonique avec le support</a>)</div><br/>On discute ? ☺️</div>"
                $("<div style='border:" + theme.border + ";border-radius:10px;padding:10px;'/>").appendTo(contentElement).dxCtrlIa({
                    bddCtrl: option.bddCtrl,
                    htmlIntro: htmlIntro,
                    showHisto:true,
                    funcQuestion: function (question, idIaConversation,funcOk) {
                        return option.bddCtrl.mAjaxCall({
                            command: "questioniadocumentation",
                            question: question,
                            id_ia_conversation: idIaConversation
                        }, function (data) {
                            funcOk(data)
                        })
                    }
                })
                contentElement.closest(".dx-popup-normal").css("border-radius", "10px")
            },
            onResizeEnd: function (e) {
                option.bddCtrl.utiCourantParaJson.width_popup_ia = e.width
                option.bddCtrl.mSaveParaJsonUtilisateur();
            }
        }).dxCtrlPopupBase("instance")
        popup.show()
    }

    this.visible = true
    this.mShow = function () { popup.show(); this.visible = true; }
    this.mHide = function () { popup.reduce(); this.visible = false; }

    this.element = function () { return container }

    mConstruit();
}